import type { Edge } from '../models/scene';

type Point = { x: number; y: number };

const isPoint = (value: unknown): value is Point => {
  if (!value || typeof value !== 'object') return false;
  const point = value as { x?: unknown; y?: unknown };
  return typeof point.x === 'number' && Number.isFinite(point.x) && typeof point.y === 'number' && Number.isFinite(point.y);
};

export const isFreeEndpointConnector = (edge: Edge): boolean => {
  if (typeof edge.from !== 'string' || typeof edge.to !== 'string') return false;
  if (!edge.from.startsWith('__freeF:') || !edge.to.startsWith('__freeT:')) return false;

  const attrs = (edge.attrs ?? {}) as Record<string, unknown>;
  return isPoint(attrs.fromPoint) && isPoint(attrs.toPoint);
};
